import apiConfig, {
  ERROR_TIMEOUT,
  DEFAULT_ERROR_MESSAGE,
} from "../../App.config";
import setLoaderAction from "./loaderAction";
import types from "../actionTypes";
import * as apiServices from "../../services/apiServices";
import * as toastAction from "../actions/toastAction";
import { isSessionValid } from "./profileAction";

/************************************ ACTIONS ****************************************/

function setEmployeebyManagerAction(applicants) {
  return {
    type: types.SET_AIR_EMPLOYEE_BY_MANAGER,
    applicants,
  };
}

function setTotalRowsAction(totalRows) {
  return {
    type: types.SET_AIR_TOTAL_ROWS,
    totalRows,
  };
}

function setCurretPageAction(currentPage) {
  return {
    type: types.SET_AIR_CURRENT_PAGE,
    currentPage,
  };
}

function setPageSizeAction(pageSize) {
  return {
    type: types.SET_AIR_PAGE_SIZE,
    pageSize,
  };
}

/************************************ ACTION CREATORS ****************************************/

export const setCurrentPage = (currentPage) => (dispatch) => {
  dispatch(setCurretPageAction(currentPage));
};

export const setPageSize = (pageSize) => (dispatch) => {
  dispatch(setPageSizeAction(pageSize));
};

export const getAirEmployeebyManager = (pagination, searchKey) => (
  dispatch
) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getAirEmployeebyManager(pagination, searchKey)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setEmployeebyManagerAction(data.employeeList));
        dispatch(setTotalRowsAction(data.pagination.totalRows));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};
